export enum EsimFlowType {
  ESIM = 'esim',
  SWAP = 'swap',
}

export enum EsimOrderStep {
  PERSONAL = 0,
  TARIFF = 1,
  FINAL = 2,
}

export enum EsimSwapStep {
  PERSONAL = 0,
  FINAL = 1,
}

export enum EsimPaymentBannerStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}
